import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { ScriptRepositoryComponent } from './scriptRepository';

@NgModule({
    imports: [SharedModule],
    declarations: [ScriptRepositoryComponent],
    entryComponents: [ScriptRepositoryComponent],
    exports: [ScriptRepositoryComponent]
})
export class ScriptRepositoryModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/scriptRepository-ang7/scriptRepository.module.ts